module.exports = __webpack_public_path__ + "static/media/APOTHEO_LABO_NESTLE_NUTRITION.6b202074.jpg";